import { ITheme } from "./themeType";

interface ThemePreviewProps {
  colors: ITheme
}

const ThemePreview: React.FC<ThemePreviewProps> = ({ colors }) => {
  return (
    <div
      className="rounded-lg shadow-lg border overflow-hidden mb-6"
      style={{
        backgroundColor: colors.background,
        color: colors.text,
        borderColor: colors.secondary,
        height: '200px', 
      }}
    >
      <div className="flex h-full">
        <div
          className="w-1/4 min-w-[120px] p-4 flex flex-col h-full"
          style={{
            backgroundColor: colors.sidebarBackground,
            color: colors.text,
            borderRight: `1px solid ${colors.secondary}`,
          }}
        >
          <div
            className="mb-4 p-2 font-bold"
            style={{
              color: colors.text,
            }}
          >
            Sidebar
          </div>
          <ul className="space-y-2 flex-1">
            <li className="hover:underline cursor-pointer">Dashboard</li>
            <li className="hover:underline cursor-pointer">Settings</li>
            <li className="hover:underline cursor-pointer">Profile</li>
          </ul>
        </div>

        <div className="flex-1 flex flex-col">
          <div
            className="p-4 font-bold text-lg"
            style={{
              backgroundColor: colors.background,
              color: colors.text,
              borderBottom: `1px solid ${colors.secondary}`,
              width: '100%', 
            }}
          >
            Preview
          </div>

          <div className="flex-1 p-6">
            <p className="mb-4" style={{ color: colors.text }}>
              This is your main content area with the selected background and text colors.
            </p>
            <button
              className="px-4 py-2 rounded font-medium"
              style={{
                backgroundColor: colors.primary,
                color: colors.primaryText,
                border: `1px solid ${colors.secondary}`,
              }}
            >
              Sample Button
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ThemePreview;
